import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import queryString from 'query-string';
import Color from 'color';

import * as styles from '../styles';
import {request} from '../containers/actions';

//@Radium
export default class Like extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static defaultProps = {
        style: {},
        showThumb: true,
        showCount: true,
    }

    state = {
        liked: this.props.liked || false,
        count: this.props.count || '-',
    }

    componentDidMount() {
        if (!this.props.liked && this.props.showThumb || !this.props.count && this.props.showCount)
            this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.target, this.props.target))
            if (!this.props.liked && this.props.showThumb || !this.props.count && this.props.showCount)
                this.fetch.bind(this)();
    }

    async fetch() {
        const response = await this.context.store.dispatch(request({
            path: '/like/?' + queryString.stringify({target: this.props.target.join(':')}),
        }));
        this.setState({
            liked: response.liked,
            likes: response.results,
            count: response.count,
        });
    }

    async fetchMore() {
        const response = await this.context.store.dispatch(request({
            path: '/like/?' + queryString.stringify({
                target: this.props.target.join(':'),
                offset: this.state.comments.length,
            }),
        }));
        this.setState(update(this.state, {
            liked: {$set: response.liked},
            likes: {$push: response.results},
            count: {$set: response.count},
        }));
    }

    render() {
        return <span
            key='hover'
            style={{
                cursor: 'pointer',
                color: this.state.liked ? styles.thirdColor : '#9a9a9a',
                ':hover': {color: this.state.liked ? (new Color(styles.thirdColor)).lighten('.1').hex() : '#5a5a5a'},
                ...this.props.style,
            }}>
            {this.props.showCount
                ? <span style={{fontSize: '.9em', display: 'inline-block', marginLeft: '.2em'}}>
                    {this.state.count.persian()}
                </span>
                : null
            }
            {this.props.showThumb
                ? <i
                    className={`fa fa-${this.state.liked ? 'thumbs-up' : 'thumbs-o-up'}`}
                    onClick={async event => {
                        event.preventDefault();
                        if (this.state.liked) {
                            await this.context.store.dispatch(request({
                                path: `/like/${this.state.liked}/`,
                                method: 'DELETE',
                            }));
                            this.setState({count: this.state.count - 1, liked: false});
                        }
                        else {
                            const response = await this.context.store.dispatch(request({
                                path: '/like/',
                                method: 'POST',
                                body: {
                                    target: this.props.target,
                                },
                            }));
                            this.setState({count: this.state.count + 1, liked: response.id});
                        }
                    }}>
                </i>
                : null
            }
        </span>;
    }
}
